import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaInstagram, FaTiktok, FaFacebookF } from 'react-icons/fa';
import { SocialPost } from '../../types/social';
import { socialService } from '../../services/SocialService';
import { SocialVideoCard } from './SocialVideoCard';

export const SocialVideoCarousel: React.FC = () => {
    const [posts, setPosts] = useState<SocialPost[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadPosts = async () => {
            try {
                const data = await socialService.getFeaturedPosts();
                setPosts(data);
            } catch (error) {
                console.error("Error loading social posts", error);
            } finally {
                setIsLoading(false);
            }
        };
        loadPosts();
    }, []);

    if (isLoading || posts.length === 0) return null;

    return (
        <section className="py-20 bg-black overflow-hidden">
            <div className="container mx-auto px-4 mb-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <div>
                        <span className="text-[#1aaaff] font-mono text-[10px] font-black uppercase tracking-[0.4em] mb-4 block">
                            Comunidad Carbon
                        </span>
                        <h2 className="text-4xl md:text-6xl font-display font-black uppercase italic text-white leading-tight">
                            Visto en <br />
                            <span className="text-zinc-800 outline-text" style={{ WebkitTextStroke: '1px #3f3f46' }}>Redes Sociales</span>
                        </h2>
                    </div>
                    
                    <div className="flex items-center gap-6 pb-2">
                        <FaInstagram className="text-zinc-500 hover:text-white transition-colors cursor-pointer" size={20} />
                        <FaTiktok className="text-zinc-500 hover:text-white transition-colors cursor-pointer" size={20} />
                        <FaFacebookF className="text-zinc-500 hover:text-white transition-colors cursor-pointer" size={20} />
                    </div>
                </div>
            </div>

            {/* Carousel Container */}
            <div className="relative">
                <div className="flex gap-4 px-4 md:px-[10%] overflow-x-auto pb-8 no-scrollbar snap-x snap-mandatory">
                    {posts.map((post) => (
                        <div key={post.id} className="min-w-[280px] md:min-w-[320px] snap-center">
                            <SocialVideoCard post={post} />
                        </div>
                    ))}
                </div>

                {/* Aesthetic Background Accents */}
                <div className="absolute top-1/2 left-0 w-64 h-64 bg-[#1aaaff]/5 rounded-full blur-[100px] pointer-events-none -translate-y-1/2 -translate-x-1/2" />
                <div className="absolute top-1/2 right-0 w-64 h-64 bg-white/5 rounded-full blur-[100px] pointer-events-none -translate-y-1/2 translate-x-1/2" />
            </div>

            <div className="container mx-auto px-4 mt-8 flex justify-center">
                <button 
                    id="btn-view-all-social"
                    className="group relative px-8 py-3 bg-zinc-900 border border-zinc-800 hover:border-white transition-all overflow-hidden"
                >
                    <span className="relative z-10 text-[10px] font-black uppercase tracking-[0.3em] text-white">
                        Explorar todo el feed
                    </span>
                    <div className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                    <style>{`
                        #btn-view-all-social:hover span {
                            color: black;
                        }
                    `}</style>
                </button>
            </div>
        </section>
    );
};
